
import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import HeroImage from "../../src/assets/image/png/BookingImage.png"; 

const Bookings = () => {
  return (
    <section style={{backgroundColor:"#FCFFF7"}} className="">
      <div className="container">
        <div className="row justify-content-between align-items-center">
          
          {/* Left Content */}
          <div className="col-lg-6 py-5 text-center text-lg-start">
            <p className="text-uppercase clrTheme fw-bold fs_17 mb-2">
              hassle-free bookings with Vasta.
            </p>
            <h1 className="fw-bold text-black fs_63 mb-3">
              Start now and get the best services
            </h1>
            <p className="text-muted mb-4">
              Download Vasta today and book your first service in minutes!
            </p>
<button style={{backgroundColor:"#044434"}} className=" px-5 border-0 py-2 rounded-3 text-white">Get Started</button>
          </div>


          <div className="col-lg-5 text-center position-relative mt-5 mt-lg-0">
            <img
              src={HeroImage}
              alt="App screen 1"
              className="img-fluid position-relative"
              style={{ zIndex: 2 }}
            />

          </div>

        </div>
      </div>
    </section>
  );
};

export default Bookings;
